import { useId } from 'react';
import Select from './components/Select';
import { selectClassNames } from 'components/list/styles';

export default function GlobalSelect({
  disabled,
  isDisabled,
  id,
  inputId,
  label,
  classNames,
  ...props
}) {
  const generatedId = useId();
  const controlId = inputId || id || generatedId;
  const control = (
    <Select
      {...props}
      ariaLabel={props.ariaLabel || (typeof label === 'string' ? label : undefined)}
      inputId={controlId}
      isDisabled={Boolean(disabled || isDisabled)}
      classNames={{ ...selectClassNames, ...classNames }}
    />
  );
  if (!label) return control;
  return (
    <div className='min-w-0 space-y-2'>
      <label htmlFor={controlId} className='block text-sm font-medium text-gray-700'>
        {label}
      </label>
      {control}
    </div>
  );
}
